import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import MultiStrikeHeader from '../../../../pages/home/openInterestHeader/MultiStrikeHeader'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'

type Props = {
    open: boolean
    onClose: () => void
    viewKey: string
}

const MultiStrikeSettingsDialog = (props: Props) => {
    const { open, onClose, viewKey } = props
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DraggableDialogTitle>Multi Strike Chart Settings</DraggableDialogTitle>
            <DialogContent sx={{ pb: '0 !important' }}>
                <MultiStrikeHeader viewKey={viewKey} />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={onClose}
                >Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default MultiStrikeSettingsDialog